// 預期工時表
import * as types from '../actionType';

let initState = [];

function finalWorkState(state = initState, action) {
  switch (action.type) {
      case types.FINAL_WORK_SHEET_SUCCESS: {
        return action.result;
      }
      default:
        return state;
  }
}


export default finalWorkState;